import { render, staticRenderFns } from "./VTaskCommentModal.vue?vue&type=template&id=808efb5c"
import script from "./VTaskCommentModal.vue?vue&type=script&lang=ts"
export * from "./VTaskCommentModal.vue?vue&type=script&lang=ts"
import style0 from "./VTaskCommentModal.vue?vue&type=style&index=0&id=808efb5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports